import { FC } from 'react'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import { Button } from 'src/components/ui'

interface IErrorState {
  onRetry?: () => void
  message?: string
  className?: string
}

// What a section shows when its data could not be loaded: a short reason and
// a retry, instead of disappearing or pretending to be empty.
const ErrorState: FC<IErrorState> = ({ onRetry, message, className }) => {
  const { t } = useTranslation()
  return (
    <div
      role="alert"
      className={clsx(
        'flex flex-col items-center gap-3 py-6 px-4 text-center text-sm text-ink bg-surface rounded-2xl',
        className,
      )}
    >
      <p>{message ?? t('load_error')}</p>
      {onRetry && (
        <Button variant="outlined" className="!h-10" onClick={onRetry}>
          {t('retry')}
        </Button>
      )}
    </div>
  )
}

export default ErrorState
